import Processing from '@/assets/icons/processing.svg?react';

export default function ProcessingBanner() {
  return (
    <div className="bg-primary-yellow-light mt-1 px-3 py-2">
      <div className="flex items-center gap-x-2.5">
        <div className="mr-2 h-10 w-10">
          <Processing />
        </div>
        <div className="">
          <p className="text-sm font-bold">Processing</p>
          <p className="text-xs">The receipt is being processed. Check back soon.</p>
        </div>
      </div>
    </div>
  );
}
